/* eslint-disable */
import Vue from "vue";
import { Consts, Http } from "mc-js-lib";

// ------------------------------------------- Start User Services ----------------------------
const VUE_APP_API_USER = process.env.VUE_APP_API_USER;

export const login = ({ email, password }) =>
  Http({
    url: `${VUE_APP_API_USER}/auth`,
    method: "post",
    body: { email, password },
    showError: true,
    errorList: { 1: Consts.Context.APP.$t("login.invalidCredentials") },
  });

export const getAllRoleActions = () =>
  Http({
    url: `${VUE_APP_API_USER}/role-actions`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const updateUserRoleActions = (data) => 
  Http({
    url: `${VUE_APP_API_USER}/role-actions`,
    method: "put",
    body: data,
    showError: true,
    errorList: {},
  });

export const getRoleActionsByRole = (role) =>
  Http({
    url: `${VUE_APP_API_USER}/role-actions/${role}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });
  
export const activateUser = ({ data }) =>
  Http({
    url: `${VUE_APP_API_USER}/activate`,
    method: "put",
    body: data,
    // showError: true,
    // errorList: { 1: Consts.Context.APP.$t("login.invalidCredentials") },
  });

export const sendVerificationCode = ({ data }) =>
  Http({
    url: `${VUE_APP_API_USER}/resend-code`,
    method: "put",
    body: data,
    // showError: true,
    // errorList: { 1: Consts.Context.APP.$t("login.invalidCredentials") },
  });

export const recoverPassword = (token, password) =>
  Http({
    url: `${VUE_APP_API_USER}/recover-password/${token}`,
    method: "post",
    body: { password },
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("settings.passwordUpdated"),
    });
    return response;
  });

export const changePassword = (currentPassword, newPassword) =>
  Http({
    url: `${VUE_APP_API_USER}/change-password`,
    method: "post",
    body: {
      password: currentPassword,
      new_password: newPassword,
    },
    showError: true,
    errorList: {
      1: Consts.Context.APP.$t("settings.wrongPassword"),
    },
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("settings.passwordUpdatedsuccessfully"),
    });
    return response;
  });

export const requesToken = ({ username }) =>
  Http({
    url: `${VUE_APP_API_USER}/forgot-password`,
    method: "post",
    body: { username },
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("settings.recoveryPassword"),
    });
    return response;
  });

export const logout = () => {
  return new Promise((resolve, reject) => {
    return resolve({ status: 200 });
  });
};

export const getMe = () =>
  Http({
    url: `${VUE_APP_API_USER}/me`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const saveUser = (data) =>
  Http({
    url: `${VUE_APP_API_USER}`,
    method: "post",
    body: data,
    showError: true,
    errorList: {
      105: Consts.Context.APP.$t("users.emailAlreadyRegistered"),
      106: Consts.Context.APP.$t("users.usernameAlreadyRegistered"),
    },
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("users.wasCreated"),
    });
    return response;
  });

export const updateUser = (data, id) =>
  Http({
    url: `${VUE_APP_API_USER}/${id}`,
    method: "put",
    body: data,
    showError: true,
    errorList: {
      105: Consts.Context.APP.$t("users.emailAlreadyRegistered"),
      106: Consts.Context.APP.$t("users.usernameAlreadyRegistered"),
    },
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("settings.profileUpdated"),
    });
    return response;
  });

export const updateMe = (data, showSuccessMessage) =>
  Http({
    url: `${VUE_APP_API_USER}/me`,
    method: "put",
    body: data,
    showError: true,
    errorList: {
      105: Consts.Context.APP.$t("users.emailAlreadyRegistered"),
      106: Consts.Context.APP.$t("users.usernameAlreadyRegistered"),
    },
  }).then((response) => {
    if (showSuccessMessage) {
      Vue.notify({
        type: "success",
        text: Consts.Context.APP.$t("settings.profileUpdated"),
      });
    }
    return response;
  });

export const getUser = (id) =>
  Http({
    url: `${VUE_APP_API_USER}/${id}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const deleteUser = (id) =>
  Http({
    url: `${VUE_APP_API_USER}/${id}`,
    method: "delete",
    body: null,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("users.wasDeleted"),
    });
    return response;
  });

export const getUsers = (course_id) =>
  Http({
    url: `${VUE_APP_API_USER}/users`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getAllUsers = (page, rows, filters = "") =>
  Http({
    url: `${VUE_APP_API_USER}/all/?page=${page}&rows=${rows}${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getUsersByCompany = (id, page, rows, filters = "") =>
  Http({
    url: `${VUE_APP_API_USER}/by-company/?company_id=${id}&page=${page}&rows=${rows}${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getUserFacilities = (id) =>
  Http({
    url: `${VUE_APP_API_USER}/${id}/facilities`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const validateUsernameAndEmail = (username, email) =>
  Http({
    url: `${VUE_APP_API_USER}/validate-username`,
    method: "put",
    body: { username: username, email: email },
    showError: true,
    errorList: {
      105: Consts.Context.APP.$t("users.emailAlreadyRegistered"),
      106: Consts.Context.APP.$t("users.usernameAlreadyRegistered"),
    },
  });

export const findUserByUsernameOrEmail = (username) =>
  Http({
    url: `${VUE_APP_API_USER}/username/${encodeURI(username)}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {
      20: Consts.Context.APP.$t("users.userNotFound"),
    },
  });

export const setDefaultPassword = (user_id) =>
  Http({
    url: `${VUE_APP_API_USER}/${user_id}/reset-password`,
    method: "put",
    body: null,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("settings.passwordUpdated"),
    });
    return response;
  });

export const activateNotificationUpload = (user_id, type, value) =>
  Http({
    url: `${VUE_APP_API_USER}/switch-${type}/${user_id}`,
    method: "put",
    body: { 'active': value },
    showError: true,
  });

export const completeInviteRegistration = (data) =>
  Http({
    url: `${VUE_APP_API_USER}/complete-invite`, // Ensure this matches your backend endpoint
    method: "post",
    body: data, // { token, password, name, phone, etc. }
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: "Registration successful",
    });
    return response;
  });

export const inviteUsers = (body) =>
  Http({
    url: `${VUE_APP_API_USER}/invite-customers`, // Ensure this endpoint exists on your BE
    method: "post",
    body, // Sending array of emails
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: "Invitations sent successfully",
    });
    return response;
  });

// ------------------------------------------- END User Services ----------------------------

// ------------------------------------------- Start Company Services ----------------------------

const VUE_APP_API_COMPANY = process.env.VUE_APP_API_COMPANY;

export const getAllCompanies = ({ page, rows, filters = "" }) =>
  Http({
    url: `${VUE_APP_API_COMPANY}?page=${page}&rows=${rows}${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getAllCompanyTypes = () =>
  Http({
    url: `${VUE_APP_API_COMPANY}-type/all`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getCompanyByCompanyId = (id) =>
  Http({
    url: `${VUE_APP_API_COMPANY}/${id}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const saveCompany = (data) =>
  Http({
    url: `${VUE_APP_API_COMPANY}`,
    method: "post",
    body: data,
    showError: true,
    errorList: {
      105: Consts.Context.APP.$t("companies.companyAlreadyRegister"),
    },
  });

export const saveCompanyType = (data) =>
  Http({
    url: `${VUE_APP_API_COMPANY}-type`,
    method: "post",
    body: data,
    showError: true,
    errorList: {
      105: Consts.Context.APP.$t("companies.companyAlreadyRegister"),
    },
  });

export const deleteCompany = (id) =>
  Http({
    url: `${VUE_APP_API_COMPANY}/${id}`,
    method: "delete",
    body: null,
    showError: true,
    errorList: {
      101: "Cannot delete company because it has facilities assigned to it.",
    },
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("users.wasDeleted"),
    });
    return response;
  });

export const activateDeactivateCompany = (id, action) =>
  Http({
    url: `${VUE_APP_API_COMPANY}/${action}/${id}`,
    method: "put",
    body: null,
    showError: true,
  });

export const updateCompany = (data, id) =>
  Http({
    url: `${VUE_APP_API_COMPANY}/${id}`,
    method: "put",
    body: data,
    showError: true,
    errorList: {
      105: Consts.Context.APP.$t("users.emailAlreadyRegistered"),
      106: Consts.Context.APP.$t("users.usernameAlreadyRegistered"),
    },
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("companies.wasUpdated"),
    });
    return response;
  });

export const updateCompanyType = (data, id) =>
  Http({
    url: `${VUE_APP_API_COMPANY}-type/${id}`,
    method: "put",
    body: data,
    showError: true,
  });

// ------------------------------------------- End Company Services ----------------------------

// ------------------------------------------- Start Facility Services ----------------------------
const VUE_APP_API_FACILITY = process.env.VUE_APP_API_FACILITY;

export const getAllFacilities = ({ page, rows, filters = "" }) =>
  Http({
    url: `${VUE_APP_API_FACILITY}/all/?page=${page}&rows=${rows}${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getAllFacilityTypes = () =>
  Http({
    url: `${VUE_APP_API_FACILITY}-type/all`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getFacilitiesByCompany = (id, page, rows, filters = "") =>
  Http({
    url: `${VUE_APP_API_FACILITY}/by-company/?company_id=${id}&page=${page}&rows=${rows}${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const saveFacility = (data) =>
  Http({
    url: `${VUE_APP_API_FACILITY}`,
    method: "post",
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("facilities.wasCreated"),
    });
    return response;
  });

export const saveFacilityType = (data) =>
  Http({
    url: `${VUE_APP_API_FACILITY}-type`,
    method: "post",
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("facilities.wasCreated"),
    });
    return response;
  });

export const deleteFacility = (id) =>
  Http({
    url: `${VUE_APP_API_FACILITY}/${id}`,
    method: "delete",
    body: null,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("facilities.wasDeleted"),
    });
    return response;
  });

export const getFacility = (id) =>
  Http({
    url: `${VUE_APP_API_FACILITY}/${id}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const updateFacility = (data, id) =>
  Http({
    url: `${VUE_APP_API_FACILITY}/${id}`,
    method: "put",
    body: data,
    showError: true,
    errorList: {
      //'105': Consts.Context.APP.$t('users.emailAlreadyRegistered'),
      //'106': Consts.Context.APP.$t('users.usernameAlreadyRegistered'),
    },
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("facilities.wasUpdated"),
    });
    return response;
  });

export const updateFacilityType = (data, id) =>
  Http({
    url: `${VUE_APP_API_FACILITY}-type/${id}`,
    method: "put",
    body: data,
    showError: true,
    errorList: {
      //'105': Consts.Context.APP.$t('users.emailAlreadyRegistered'),
      //'106': Consts.Context.APP.$t('users.usernameAlreadyRegistered'),
    },
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("facilities.wasUpdated"),
    });
    return response;
  });

// ------------------------------------------- End Facility Services ----------------------------

// ------------------------------------------- Start Location Services ----------------------------
const VUE_APP_API_LOCATION = process.env.VUE_APP_API_LOCATION;

export const getLocationsByFacility = (id) =>
  Http({
    url: `${VUE_APP_API_LOCATION}/by-facility/?facility_id=${id}&page=1&rows=100`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getAllLocations = ({ page, rows, filters = "" }) =>
  Http({
    url: `${VUE_APP_API_LOCATION}/all/?page=${page}&rows=${rows}${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getLocation = (id) =>
  Http({
    url: `${VUE_APP_API_LOCATION}/${id}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getLocationsByCompany = (id, page, rows, filters = "") =>
  Http({
    url: `${VUE_APP_API_LOCATION}/by-company/?company_id=${id}&page=${page}&rows=${rows}${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const saveLocation = (data) =>
  Http({
    url: `${VUE_APP_API_LOCATION}`,
    method: "post",
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("locations.wasCreated"),
    });
    return response;
  });

export const updateLocation = (data, id) =>
  Http({
    url: `${VUE_APP_API_LOCATION}/${id}`,
    method: "put",
    body: data,
    showError: true,
    errorList: {
      //'105': Consts.Context.APP.$t('users.emailAlreadyRegistered'),
      //'106': Consts.Context.APP.$t('users.usernameAlreadyRegistered'),
    },
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("locations.wasUpdated"),
    });
    return response;
  });

export const deleteLocation = (id) =>
  Http({
    url: `${VUE_APP_API_LOCATION}/${id}`,
    method: "delete",
    body: null,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("locations.wasDeleted"),
    });
    return response;
  });

// ------------------------------------------- END Location Services ----------------------------

// ------------------------------------------- Start Detector Services ----------------------------
const VUE_APP_API_DETECTORS = process.env.VUE_APP_API_DETECTORS;
const VUE_APP_API_DEVICE_TYPE = process.env.VUE_APP_API_FIRMWARE;

export const getDetector = (id) =>
  Http({
    url: `${VUE_APP_API_DETECTORS}/${id}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getAllDetectors = ({ page = 1, rows = 100, filters = "" }) =>
  Http({
    url: `${VUE_APP_API_DETECTORS}/all?page=${page}&rows=${rows}${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getDetectorByFacility = (id) =>
  Http({
    url: `${VUE_APP_API_DETECTORS}/by-facility/${id}?page=1&rows=100`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getDetectorByLocation = (id) =>
  Http({
    url: `${VUE_APP_API_DETECTORS}/by-location/${id}?page=1&rows=100`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getDetectorsByCompany = (id, page, rows, filters = "") =>
  Http({
    url: `${VUE_APP_API_DETECTORS}/by-company/${id}?page=${page}&rows=${rows}${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getDetectorsType = () =>
  Http({
    url: `${VUE_APP_API_DEVICE_TYPE}/device-type/`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getFilesType = () =>
  Http({
    url: `${VUE_APP_API_DEVICE_TYPE}/all-file-type/`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const deleteDetector = (id) =>
  Http({
    url: `${VUE_APP_API_DETECTORS}/${id}`,
    method: "delete",
    body: null,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("detector.wasDeleted"),
    });
    return response;
  });

export const updateDetector = (data, id) =>
  Http({
    url: `${VUE_APP_API_DETECTORS}/change-location/${id}`,
    method: "put",
    body: data,
    showError: false,
  }).then((response) => {
    Vue.notify({
      type: "success",
      text: Consts.Context.APP.$t("detector.wasUpdated"),
    });
    return response;
  });

export const activateDeactivateDetector = (id, action) =>
  Http({
    url: `${VUE_APP_API_DETECTORS}/${action}/${id}`,
    method: "put",
    body: null,
    showError: true,
  });

export const assignNewDetector = (data) =>
  Http({
    url: `${VUE_APP_API_DETECTORS}/self-assign`,
    method: "post",
    body: data,
    showError: true,
    errorList: {
      20: "The detector was not found, verify the serial number",
      300: "This serial number is already registered. Please verify the serial number.",
      11: "The bluetooth pin is incorrect, verify the number and try again.",
    },
  });

export const getDetectorsLogs = ({ page = 1, rows = 100 }) =>
  Http({
    url: `${VUE_APP_API_DETECTORS}-log/all?page=${page}&rows=${rows}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const bulkDetectors = (companyId, data) =>
  Http({
    url: `${VUE_APP_API_DETECTORS}/bulk/assign/${companyId}`,
    method: "post",
    body: data,
    showError: true,
    errorList: {
      20: "The detector was not found, verify the serial number",
      300: "This serial number is already registered. Please verify the serial number.",
      11: "The bluetooth pin is incorrect, verify the number and try again.",
    },
  });

export const selfBulkDetectors = (data) =>
  Http({
    url: `${VUE_APP_API_DETECTORS}/bulk/self-assign`,
    method: "post",
    body: data,
    showError: true,
    errorList: {
      20: "The detector was not found, verify the serial number",
      300: "This serial number is already registered. Please verify the serial number.",
      11: "The bluetooth pin is incorrect, verify the number and try again.",
    },
  });

// ------------------------------------------- End Detector Services ----------------------------
// ------------------------------------------- Start Firmware Services ----------------------------

const VUE_APP_API_FIRMWARE = process.env.VUE_APP_API_FIRMWARE;

export const getFirmwareVersion = () =>
  Http({
    url: `${VUE_APP_API_FIRMWARE}/firmware`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const uploadFirmwareVersion = ({ body }) =>
  Http({
    url: `${VUE_APP_API_FIRMWARE}/firmware`,
    method: "post",
    body,
    showError: true,
    errorList: {},
  });

export const updateFirmware = ({ firmwareId, body }) =>
  Http({
    url: `${VUE_APP_API_FIRMWARE}/firmware/${firmwareId}`,
    method: "put",
    body,
    showError: true,
    errorList: {},
  });

  export const getFirmwareVersionCompatibility = () =>
    Http({
      url: `${VUE_APP_API_FIRMWARE}/firmware/get-all-compatibility`,
      method: "get",
      body: null,
      showError: true,
      errorList: {},
    });

  export const getFirmwareVersionCompatibilityV2 = () =>
    Http({
      url: `${VUE_APP_API_FIRMWARE}/firmware/verify-compatibility-v2?device_type=AF&firmware_version=0.15.00&bootloader_version=1.2.0&wireless_version=1.15.0`,
      method: "get",
      body: null,
      showError: true,
      errorList: {},
    });

  export const updateFirmwareVersionCompatibility = ({ matrix_id, body }) =>
    Http({
      url: `${VUE_APP_API_FIRMWARE}/firmware/update-compatibility/${matrix_id}`,
      method: "put",
      body,
      showError: true,
      errorList: {},
    });

// ------------------------------------------- End Firmware Services ----------------------------
// ------------------------------------------- Start Factory Services ----------------------------

const VUE_APP_API_FACTORY = process.env.VUE_APP_API_FACTORY;

export const getFactoryDetectors = () =>
  Http({
    url: `${VUE_APP_API_FACTORY}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getFactoryDetectorsExcel = ({ filters }) =>
  Http({
    url: `${VUE_APP_API_FACTORY}?${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getFactoryDetectorsAvailable = ({ page, rows, filters = "" }) =>
  Http({
    url: `${VUE_APP_API_FACTORY}/all?page=${page}&rows=${rows}${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getFactoryIOBoards = ({ page, rows, filters = "" }) =>
  Http({
    url: `${VUE_APP_API_FACTORY}/io-board/all?page=${page}&rows=${rows}${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getFactoryLogicBoards = ({ page, rows, filters = "" }) =>
  Http({
    url: `${VUE_APP_API_FACTORY}/logic-board/all?page=${page}&rows=${rows}${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

export const getFactorySensors = ({ page, rows, filters = "" }) =>
  Http({
    url: `${VUE_APP_API_FACTORY}/sensor/all?page=${page}&rows=${rows}${filters}`,
    method: "get",
    body: null,
    showError: true,
    errorList: {},
  });

// ------------------------------------------- End Factory Services ----------------------------
